
import { useState } from "react";
import { playRandomDiceSound } from "@/utils/audioUtils";

export function useDiceValue() {
  const [diceValue, setDiceValue] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);
  
  const rollDice = (duration: number = 1500): Promise<number> => {
    setIsSpinning(true);
    
    // Play random dice sound
    playRandomDiceSound().catch(error => {
      // Just log the error and continue - don't break the app if audio fails
      console.warn("Error playing dice sound:", error);
    });
    
    return new Promise((resolve) => {
      const startTime = Date.now();
      const rollInterval = setInterval(() => {
        const randomValue = Math.floor(Math.random() * 6) + 1;
        setDiceValue(randomValue);
        
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime >= duration) {
          clearInterval(rollInterval);
          
          // Final result
          const finalValue = Math.floor(Math.random() * 6) + 1;
          setDiceValue(finalValue);
          setIsSpinning(false);
          resolve(finalValue);
        }
      }, 100);
    });
  };
  
  return {
    diceValue,
    setDiceValue,
    isSpinning,
    setIsSpinning,
    rollDice
  };
}
